import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importMarketplaceErrorScreenContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "MarketplaceErrorScreenContainer" */
                '@perpay-web/fintech/components/containers/MarketplaceErrorScreenContainer'
            ),
    );
